export {
  Image,
  type ImageProps,
  type ImageSizes,
  getImageLoader,
} from '../../compositions/shared/Image';

export { addSizesToImageProps } from '../../utils/image';
